import { MaterialOption } from '@shared/models/material-option';
import { AdditionalInfoIds } from '../models/additional-info';

/**
 * Returns a partial AdditionalInfoIds with null for every field
 * whose visibility is turned off by the given MaterialOption.
 * Returns null if nothing needs clearing.
 */
export const getDisabledFieldsClearPayload = (materialOption: MaterialOption): Partial<AdditionalInfoIds> | null => {
	const patch: Partial<AdditionalInfoIds> = {};
	let hasChanges = false;

	if (!materialOption.PrepDesignVisible) {
		patch.PreparationDesignBuccalId = null;
		patch.PreparationDesignBuccal = null;
		patch.PreparationDesignLingualId = null;
		patch.PreparationDesignLingual = null;
		hasChanges = true;
	}

	if (!materialOption.MarginDesignVisible) {
		patch.MarginDesignBuccalId = null;
		patch.MarginDesignBuccal = null;
		patch.MarginDesignLingualId = null;
		patch.MarginDesignLingual = null;
		hasChanges = true;
	}

	if (!materialOption.ShadeVisible) {
		patch.ShadeIncisal = null;
		patch.ShadeGingival = null;
		hasChanges = true;
	}

	if (!materialOption.StumpShadeVisible) {
		patch.StumpfShade = null;
		hasChanges = true;
	}

	return hasChanges ? patch : null;
};
